import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { createSelectorRx } from "keautils";

import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.EntregaIngresosAUsuarioDto;
import { columnas } from "./columns";
const resource = resources.EntregaIngresosZE;
interface props {
    idUsuarioZE: number | undefined | null;
    Session: models.Session;

}

class EntregaIngresoAUsuarioListNoRx extends React.PureComponent<props> {
    idUsuarioZE = (x: props) => x.idUsuarioZE;
    modalManager = kea.createModalManager();

    onCancelar = async (x: Entity) => {

        if (this.props.Session.Permisos.EntregaIngresosUsuarioZE.CancelarEntregaIngresos) 
        {
            var ccc = await this.modalManager.showModal(CapturaMotivoModal, undefined, null );

            if (ccc.value?.Motivo != null) {
                const data = await resource.CancelarEntregaIngreso(x.IdRegistro, ccc.value.Motivo);
                await kea.message("La entrega de ingreso fue cancelada");
            }
        }
        else
        {kea.message("No tiene permisos para cancelar de entrega de ingresos")}
    }

    onGenerarReporte = async (x: Entity) => {

        if (this.props.Session.Permisos.EntregaIngresosUsuarioZE.GenerarReporteEntregaIngresos) 
        {
            if (await kea.yesno("Generar reporte de entrega de ingresos a usuario de zona extendida?", x.NombreUsuario)) {
                const data = await resource.GenerarReporte(x.IdRegistro);
                kea.download(kea.base64ToBlob(data, 'application/pdf'), "Reporte entrega de ingresos a usuario.pdf");
            }
        }
        else
        {kea.message("No tiene permisos para generar el reporte de entrega de ingresos")}
    }

    items = observeResource(resource.query);
    onVer = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this, this.props.Session.Permisos);
        return (
            <div>
                <kea.Title titulo="Entrega de ingresos a proveedor ZE" onRegresar={this.onRegresar}>
                    { this.props.Session.Permisos.EntregaIngresosUsuarioZE.Agregar && <kea.AgregarButton onClick={this.onAgregar} />}
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"EntregaIngresoAUsuarioListCookieKey"} items={this.items} />
                {this.modalManager.component}
            </div>
        )
    }
}

const CargaZEListRX = componentToRx(EntregaIngresoAUsuarioListNoRx);

export class EntregaIngresoAUsuarioList extends React.PureComponent {
    session = () => resources.User.SessionRx;

    render() {
        return (
            <CargaZEListRX idUsuarioZE={null} Session={resources.User.SessionRx} />
        )
    }
}

type Entity2 = models.ParamCancelarEntrega;

interface ModalProps extends kea.ModalProps<Entity2, Entity2|null, undefined> {
}

export function validar(x: Entity2) {
    const rules: validation.Rules<Entity2> = {Motivo: validation.required};
    return validation.getErrors(rules, x);
}

class CapturaMotivoModal extends React.PureComponent<ModalProps> {
    value = (props: Entity2) => props;
    errors = createSelectorRx(this.value, x => validar(x));
    getField = formfields(() => this.props, () => this.errors(this.props.value));

    onCerrar = () => {
        
        this.props.onClose(this.props.value);
    }

    render() {
        
        const value = this.props.value  ;
        const Text = this.getField(kea.Text);
        return (
            <kea.Modal
                onClose={this.onCerrar}
                buttons={[
                    <kea.GuardarButton onClick={() => this.props.onClose(this.props.value)} disabled={validation.hasError(this.errors(this.props.value))} />
                ]}
                title="Crear Inicio de Viaje"
            >
                {kea.autogrid(3, [
                    <Text field="Motivo" label="Motivo de cancelacion" />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/entregaingresoZE/list/list.tsx